import r from "./index513.js";
import { resolveComponent as n, createElementBlock as i, openBlock as o, normalizeClass as l, createBlock as a, createCommentVNode as s, createVNode as m, withCtx as c, createTextVNode as u, toDisplayString as h } from "vue";
import k from "./index231.js";
const f = ["data-component"];
function C(e, _, M, I, V, g) {
  const d = n("ms-headline"), t = n("cs-link-group"), p = n("cs-expander");
  return o(), i("div", {
    "data-component": e.$options.name,
    class: l({
      "mb-40": !e.isInVIM && e.isScreenM
    })
  }, [
    e.headline ? (o(), a(d, {
      key: 0,
      type: "h3",
      class: "mb-16"
    }, {
      default: c(() => [
        u(h(e.headline), 1)
      ]),
      _: 1
    })) : s("", !0),
    m(t, {
      links: e.computedLinks,
      hasSingleColumn: !e.isInVIM,
      hasMaxColumns: e.hasMaxColumns && e.isInVIM
    }, null, 8, ["links", "hasSingleColumn", "hasMaxColumns"]),
    e.showExpander ? (o(), a(p, {
      key: 1,
      expanded: e.isExpanded,
      "onUpdate:expanded": e.onUpdateExpanded
    }, null, 8, ["expanded", "onUpdate:expanded"])) : s("", !0)
  ], 10, f);
}
const E = /* @__PURE__ */ k(r, [["render", C]]);
export {
  E as default
};
